import styled from "styled-components";

const Icon = styled.i`
    font-weight: lighter;
    cursor: pointer;
`;

export default Icon;
